import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPassword, hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import { QuoteBlock } from "../components/QuoteBlock";
import ProtectedSection from "../components/ProtectedSection";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import essay2607Thumbnail from "../image/articles/essay260701.webp";
import image1 from "../image/articles/essay260801.webp";
import image2 from "../image/articles/essay260802.webp";
import image3 from "../image/articles/essay260803.webp";
import image4 from "../image/articles/essay260804.webp";
import image5 from "../image/articles/essay260805.webp";
import image6 from "../image/articles/essay260806.webp";
import image7 from "../image/articles/essay260807.webp";
import image8 from "../image/articles/essay260808.webp";
import image9 from "../image/articles/essay260809.webp";
import image10 from "../image/articles/essay260810.webp";
import image11 from "../image/articles/essay260811.webp";
import image12 from "../image/articles/essay260812.webp";
import image13 from "../image/articles/essay260813.webp";
import image14 from "../image/articles/essay260814.webp";
import image15 from "../image/articles/essay260815.webp";


function Essay2608(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const images1 = [image2, image3,  image4, image5, ];
    const images2 = [image6, image7, image15];
    const images3 = [image8, image9, image10];
    const images4 = [image11, image12, image13, image14, ];
    
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_SECTION_PASSWORDS
      );
      useMetaTags({
        title: '26.08. 회고 - Lynkim',
        description: '첫 프로젝트 런칭',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'26.08. 회고 (작성중)'}
                titleEn={'26.08. Review'}
                description={<div>첫 프로젝트 런칭</div>}
                descriptionEn={<div></div>}
                category={'essay'}
                date={'2026.09.05.'}
                thumbnail={image1}

            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
           <ArticleTextSection
                title = '짧은 생각들'
                titleEn = 'Snippets'
                
                marginBottom={true}
                description={<div>
                    
                    
                    </div>}
                descriptionEn={<div>
                     </div>}
                   />

                <ArticleImageLayout 
                 images={images2}
                />
                <ArticleImageLayout 
                 images={images3}
                />
                
                

                <ArticleTextSection
                  title = {<div>첫 프로젝트 런칭</div>}
                  titleEn = {<div>Tattoo</div>}
                  marginBottom={true}
                  marginTop={true}
                  description={<div>
                    "투자본능 테스트"라는 이름을 붙였다.</div>}
                    descriptionEn={<div>
                    </div>}

                    />
                <ArticleImageLayout 
                 images={images1}
                />
                <ProtectedArticleGroup
                                lockPassword={sectionLockHashes}
                                description="이 글을 잠겨있어요"
                            >
                <ArticleTextSection
                  title = {<div>가장 예쁘면서 못났고, 즐거우며 슬펐던 날들 </div>}
                  titleEn = {<div>Tattoo</div>}
                  marginBottom={true}
                  marginTop={true}
                  description={<div>
                  </div>}
                    descriptionEn={<div>
                   </div>}

                    />
                </ProtectedArticleGroup>
                <ArticleImageLayout 
                 images={images4}
                />

        <NextItem to='/Essay2607' thumbnail={essay2607Thumbnail} nextProjectTitle='26.07. 회고'/>

        <BackButton/>
        </div>
        </ProtectedPage>
        </>
      )
  }

export default Essay2608;